import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ActionSheetController, AlertController, MenuController, ModalController, NavController, Platform } from '@ionic/angular';
import { UserDataService } from './services/user-data.service';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { UtilService } from './services/util.service';
declare var RazorpayCheckout: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  networkAlert:any;
  disconnectSubscription:any;
  connectSubscription:any;
  public selectedIndex = 0;
  appVer:any='';
  public appPages = [
    {
      title: 'Dashboard',
      url: 'prod/dashboard',
      icon: 'apps'

    },
    {
      title: 'Help',
      url: 'prod/dashboard',
      icon: 'help-circle'

    },
    {
      title: 'Exam History',
      url: 'prod/dashboard/exam-history',
      icon: 'file-tray'

    },
    {
      title: 'Logout',
      url: 'prod/auth/login',
      icon: 'log-out'
    }
  ];
  constructor(
    private platform: Platform,
    private menuCtrl: MenuController,
    private router: Router,
    private user: UserDataService,
    private network: Network,
    private util: UtilService,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private actionCtrl: ActionSheetController,
    private navCtrl: NavController,
    private appVersion: AppVersion
  ) {
    this.initializeApp();
  }
  initializeApp() {
    //
    this.platform.ready().then(() => {
      this.appVersion.getVersionNumber().then(res => {
        this.appVer = res;
      }).catch(error => {
       // alert(error);
      });

      this.platform.backButton.subscribeWithPriority(1, () => { // to disable hardware back button on whole app
      });     
      this.disconnectSubscription = this.network.onDisconnect().subscribe(async () => {
        console.log('network was disconnected :-(');
        this.networkAlert = await this.util.createAlert('No Internet',     false, 'Please Check you internet Connection and try again',{
        text: '',
        role: '',
        cssClass: 'secondary',
        handler: async () => {}
        });
        this.networkAlert.present();
        });
        this.connectSubscription = this.network.onConnect().subscribe(() => {
        console.log('network connected!');
        if(this.networkAlert) {
        this.networkAlert.dismiss();
       // this.checkUser();
        }
        });
        
     
      
    });
   
    
  }
  async ngOnInit() {
    console.log('ngOnInit');
    this.menuCtrl.enable(true);
    this.handleHarwareBack();

  }
  
  async menuNavigation(url) {
    console.log('url is ', url);
    if (url == 'prod/auth/login') {
      this.menuCtrl.enable(false);
      await this.user.removeUserLoginData();
      await this.user.removeStudentLoginData();
      await this.user.removeUserContact();
      this.router.navigate([url], { replaceUrl: true });
    } else {
      this.router.navigate([url]);
    }
  }
  private async handleHarwareBack() {
    const routesArr = ['/prod/dashboard'];
    //
    this.platform.backButton.subscribeWithPriority(999, async () => {
      if (this.modalCtrl.getTop()) {
        const modal = await this.modalCtrl.getTop();
        const actionSheet = await this.actionCtrl.getTop();
        // console.log(modal);
        if (actionSheet) {
          this.actionCtrl.dismiss();
          return;
        }
        if (modal) {
          this.modalCtrl.dismiss();
          return;
        } else {
          const currentURL = this.router.url;
          const ifRootPage = routesArr.some((path) => path == currentURL);
          console.log('current url is ...', this.router.url, ifRootPage);
          if (!ifRootPage) {
            this.navCtrl.pop();
          } else if (ifRootPage) {
            navigator['app'].exitApp();
          }
        }
      }
    });
  }
}
